import React, { useEffect } from "react";
import "./MedicalBanner.css";

const MedicalBanner = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const products = [
    {
      src: require("./CarouselImages/Anabolics/TestP.jpeg"),
      label: "Anabolics",
      alt: "Anabolics Product",
    },
    {
      src: require("./CarouselImages/sarms/LGD4033.jpg"),
      label: "SARMs",
      alt: "Sarms Product",
    },
  ];

  return (
    <div>
    {/* <SearchPage/> */}
    <section className="medical-banner-container">
      <div className="intro-banner">
        <div className="banner-text">
          <h1>Top Quality <span>Medical Products</span></h1>
          <p>
            We prioritize the health and safety of our clients by providing
            best-in-class medical supplies and professional support.
          </p>
        </div>

        <div className="banner-products">
          {products.map((product, index) => (
            <div className="product-card" key={index}>
              <img src={product.src} alt={product.alt} />
              <span>{product.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="info-section">
        <div className="info-card info-primary">
          <h3>📞 Got Questions?</h3>
          <p>Contact our support for any medical or general inquiry.</p>
        </div>
        <div className="info-card info-warning">
          <h3>⚠️ Safety First</h3>
          <p>Use under professional supervision. Keep away from children.</p>
        </div>
        <div className="info-card info-secondary">
          <p>Email us directly at:</p>
          <strong>biogenixlaboratories@gmail.com</strong>
        </div>
      </div>
    </section>
    </div>
  );
};

export default MedicalBanner;
